import { Stack } from "@mui/material";
import { TextArea } from "@src/appV2/redesign/system/ui-components";
import { useState } from "react";

import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { IconButton } from "../redesign/components/IconButton";
import { useCreateNewsFeedItemComment } from "./api/useCreateNewsFeedItemComment";

export interface NewsFeedItemAddCommentInputProps {
  newsFeedItemId: string;
}

export function NewsFeedItemAddCommentInput(props: NewsFeedItemAddCommentInputProps) {
  const { newsFeedItemId } = props;

  const [content, setContent] = useState<string | undefined>();
  const { mutateAsync, isLoading } = useCreateNewsFeedItemComment(newsFeedItemId, {
    meta: { userSuccessMessage: "Your comment has been added!" },
  });

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <TextArea
        value={content}
        disabled={isLoading}
        placeholder="Add your comment"
        onChange={(event) => {
          setContent(event.currentTarget.value || undefined);
        }}
      />
      <IconButton
        size="small"
        iconType="arrow-up"
        variant="contained"
        aria-label="Add comment"
        disabled={isLoading || !content}
        onClick={async () => {
          if (!content) {
            return;
          }

          await mutateAsync({ data: { type: "news-feed-item-comment", attributes: { content } } });
          logEvent(APP_V2_USER_EVENTS.NEWS_FEED_COMMENT_ADDED, { content });
          setContent("");
        }}
      />
    </Stack>
  );
}
